import { toaster } from "@/components/ui/toaster";

export const mustStartReviewToastCooldownMs = 2500;

export const showMustStartReviewToast = (
  lastMustStartReviewToastAtRef: { current: number },
) => {
  const now = Date.now();
  if (
    now - lastMustStartReviewToastAtRef.current <
    mustStartReviewToastCooldownMs
  ) {
    return;
  }
  lastMustStartReviewToastAtRef.current = now;

  toaster.create({
    type: "error",
    title: 'Para gestionar el Onboarding, la solicitud debe estar "En revisión"',
  });
};

export const showRequireChangesSuccessToast = () => {
  toaster.create({
    type: "success",
    title: "Cambios requeridos enviados.",
  });
};

export const showApproveSuccessToast = () => {
  toaster.create({
    type: "success",
    title: "Se aprobó el Onboarding jurídico",
  });
};

export const showApproveErrorToast = () => {
  toaster.create({
    type: "error",
    title: "No se pudo aprobar el Onboarding jurídico",
  });
};

export const showStartReviewSuccessToast = () => {
  toaster.create({
    type: "success",
    title: "Solicitud pasada a revisión con éxito.",
  });
};